import { useCallback } from 'react';

import { captureMessage } from 'src/lib/sentry';
import { useProjectActions, useProjectFolderActions } from 'src/store';

export const useDeleteProject = () => {
  const projectActions = useProjectActions();
  const projectFolderActions = useProjectFolderActions();
  const project = projectActions.getCurrentProject();

  return useCallback(async () => {
    try {
      await projectActions.deleteProject(project.id);
      projectFolderActions.decreaseFolderProjectCount(project.projectFolder?.id);
    } catch (error) {
      captureMessage('Failed attempt to auto-delete an empty project', {
        level: 'warning',
        extra: {
          error: error.toString(),
          source: 'ProjectPage -> useOnProjectPageBackClick',
        },
      });
    }
  }, [projectActions, projectFolderActions, project]);
};
